import React, { Component } from 'react';
import API from '../../api/api';
import './winterGamesAnswer.less';
import zhCN from 'antd/es/locale/zh_CN';
import moment from 'moment';
import { Button, DatePicker, message, ConfigProvider, Select, Input, Icon } from 'antd';
var uploader = require('../../thirdTool/alioss/upload.js');
const { RangePicker } = DatePicker;
const { Option } = Select;
const key = 'updatable';

class WinterGamesAnswer extends Component {
    constructor(props) {
        super(props);
    }
    state = {
        playId: '',
        isQ: false,
        defaultMoment: [],// 查看活动详情时的初始化moment数组
        data: null
    }

    componentDidMount() {
        if (this.getQueryString('moduleId') && this.getQueryString('moduleId') != 'null') {
            this.winnerModuleDetail({
                moduleId: this.getQueryString('moduleId')
            });
        } else {
            this.setState({
                data: {
                    moduleId: '',
                    moduleName: '',
                    startTime: '',
                    endTime: '',
                    moduleDesc: '',
                    questionList: [
                        {
                            quesType: 1,
                            quesDesc: '',
                            options: [],
                        }
                    ]
                }
            })
        }
        this.initUpload();
        this.setState({
            playId: this.getQueryString('activityId')
        })
        // winnerModuleDetail
    }



    initUpload() { //初始化视频上传
        let self = this;
        setTimeout(() => {
            let buttonDiv = document.getElementById('moduleDesc');
            if (buttonDiv) {
                uploader({
                    serverUrl: window.location.origin + '/promotion/oss/policy',
                    upload_button: 'moduleDesc',
                    multi: false,
                    extensions: 'jpg,png,bmp,jpeg',
                    added: function () {
                    },
                    success: function (file_url, file) {
                        self.getPictureInfo(file_url).then(obj => {
                            let { data } = self.state;
                            data.moduleDesc = obj
                            self.setState({ data })
                            buttonDiv.style.backgroundImage = 'url(' + obj.picture + ')';
                        });
                    },
                    error: function (msg) {
                        message.error(msg)
                    }
                })
            }
        }, 100)
    }

    async getPictureInfo(url) { // 获取图片信息
        let result = await API.syncPic({ url: url });
        if (!result) return;
        if (result) {
            let picObj = {
                picture: url,
                width: result.ImageWidth.value,
                height: result.ImageHeight.value
            }
            return picObj;
        }
        else {
            message.error(result.msg);
        }
    };


    getQueryString(name) {//解析url
        const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        const urlObj = window.location;
        var r = urlObj.href.indexOf('#') > -1 ? urlObj.hash.split("?")[1].match(reg) : urlObj.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]); return null;
    }

    async winnerModuleEdit() {
        const { isQ, playId } = this.state;
        if (isQ) return;
        this.setState({ isQ: true });
        let data = this.state.data;
        data.startTime = Math.floor(data.startTime / 1000);
        data.endTime = Math.floor(data.endTime / 1000);
        data.playId = playId;
        data.questionList = JSON.stringify(data.questionList)
        data.moduleDesc = JSON.stringify(data.moduleDesc)
        let result = await API.winnerModuleEdit(data);
        if (result.status == 1) {
            message.success({ content: '保存成功', key, duration: 0.6 });
            this.props.history.go(-2)
            this.setState({ isQ: false });
            return
        }
        message.error({ content: result.msg, key, duration: 1 });
    }

    async winnerModuleDetail(param) {
        let result = await API.winnerModuleDetail(param);
        if (result.status == 1) {
            let data = result.data;
            data.startTime = data.startTime * 1000;
            data.endTime = data.endTime * 1000;
            let { defaultMoment } = this.state;
            defaultMoment.push(moment(data.startTime), moment(data.endTime));
            this.setState({
                data,
                defaultMoment
            }, () => {
                if (data.moduleDesc) {
                    data.moduleDesc = JSON.parse(data.moduleDesc);
                    let moduleDescDiv = document.getElementById('moduleDesc');
                    moduleDescDiv.style.backgroundImage = 'url(' + data.moduleDesc.picture + ')';
                }
            })
            return
        }
        message.error({ content: result.msg, key, duration: 1 });
    }

    onSearchDateChange(date) {
        let { guideListSearchCondition } = this.state;
        console.log('date', date)
        let startTime = '', endTime = '';
        if (date.length == 0) {
            startTime = ''; endTime = '';
        } else {
            startTime = new Date(date[0].format('L')).getTime() / 1000;
            endTime = (new Date(date[1].format('L')).getTime() + 86400000) / 1000
        }
        guideListSearchCondition.startTime = startTime;
        guideListSearchCondition.endTime = endTime;
        this.setState({ guideListSearchCondition });
    }

    inputNumberChange(event) {
        let { guideListSearchCondition } = this.state;
        guideListSearchCondition.crewNumber = event.target.value;
        this.setState({ guideListSearchCondition })
    }

    onSelectChange(type, index, value) {//下拉框更改
        console.log('onSelectChange', type, index, value)
        let { data } = this.state;
        data.questionList[index][type] = value;
        if (value == 1) {
            data.questionList[index].options = [];
        }
        if (value == 2) {
            data.questionList[index].options = ['', ''];
        }
        if (value == 3) {
            data.questionList[index].options = ['', '', ''];
        }
        this.setState({ data })
    }

    inputItemChange(type, e) {
        let value = e.target.value;
        let { data } = this.state;
        switch (type) {
            case 'moduleName':
                data.moduleName = value
                break;
            case 'moduleDesc':
                data.moduleDesc = value
                break;
        }
        this.setState({ data })
    }

    inputItemChange_(type, index, e) {
        console.log('inputItemChange_', type, index, e.target.value)
        let value = e.target.value;
        let { data } = this.state;
        data.questionList[index][type] = value
        this.setState({ data })
    }

    inputItemChange2(index, optionsIndex, e) {
        console.log('inputItemChange2', index, optionsIndex, e.target.value)
        let value = e.target.value;
        let { data } = this.state;
        data.questionList[index].options[optionsIndex] = value
        this.setState({ data })
    }

    addOptionsItem(index) {
        let { data } = this.state;
        let options = data.questionList[index].options;
        options[options.length] = '';
        data.questionList[index].options = options;
        this.setState({ data });
    }

    delOptionsItem(index, optionsIndex, quesType) {
        console.log('quesType', index, optionsIndex, quesType)
        let { data } = this.state;
        if (data.questionList[index].options.length > 2) {
            data.questionList[index].options.splice(optionsIndex, 1);
        } else {
            message.error({ content: '至少保留2个选项', key, duration: 1 });
        }
        this.setState({ data });
    }


    addQuestion() {
        let { data } = this.state;
        data.questionList.push(
            {
                quesType: 1,
                quesDesc: '',
                options: [],
            }
        );
        this.setState({ data });
    }

    dateChange(dates) {
        let { data } = this.state;
        if (dates.length == 0) {
            data.startTime = 0;
            data.endTime = 0;
        } else {
            if (dates[0].valueOf()) {
                data.startTime = dates[0].valueOf();
            }
            if (dates[1].valueOf()) {
                data.endTime = dates[1].valueOf();
            }
        }
        this.setState({ data })
    }

    render() {
        const {
            data,
            defaultMoment,
        } = this.state;
        if (!data) return null;
        const { moduleName, questionList } = data;
        return (
            <ConfigProvider locale={zhCN}>
                <div className="winterGamesAnswer">
                    <div className="inputItem">
                        <span className="inputTitle">模块名称</span>
                        <Input className="inputBlock" value={moduleName} placeholder="请输入模块名称" onChange={this.inputItemChange.bind(this, 'moduleName')}></Input>
                    </div>
                    <div className="inputItem">
                        <span className="inputTitle">时间</span>
                        <RangePicker className="datePicker" defaultValue={defaultMoment} format="YYYY-MM-DD HH:mm:ss" showTime={{ defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('11:59:59', 'HH:mm:ss')] }} onChange={this.dateChange.bind(this)} />
                    </div>
                    <div className="inputItem">
                        <span className="inputTitle">说明图</span>
                        <div id="moduleDesc" className="moduleDesc"></div>
                    </div>
                    <div className="questionList">
                        <span className="inputTitle">题目</span>
                        {
                            questionList.map((item, index) => {
                                return (
                                    <div className='questionItem' key={index}>
                                        <div className='quesType'>
                                            <Select className="selectBlock" defaultValue={item.quesType} onChange={this.onSelectChange.bind(this, 'quesType', index)}>
                                                <Option value={1}>文本</Option>
                                                <Option value={2}>单选</Option>
                                                <Option value={3}>多选</Option>
                                            </Select>
                                            <Input className="inputBlock" value={item.quesDesc} placeholder={`请输入问题${index + 1}`} onChange={this.inputItemChange_.bind(this, 'quesDesc', index)}></Input>
                                        </div>
                                        <div className='options'>
                                            {
                                                item.options && item.options.length > 0 &&
                                                item.options.map((optionsItem, optionsIndex) => {
                                                    return (
                                                        <div className='optionsItem' key={optionsIndex}>
                                                            <Input className="inputBlock" value={optionsItem} placeholder={`选项${optionsIndex + 1}`} onChange={this.inputItemChange2.bind(this, index, optionsIndex)}></Input>
                                                            <Icon type="plus-circle" className='icon' theme="twoTone" onClick={this.addOptionsItem.bind(this, index)} />
                                                            <Icon type="minus-circle" className='icon' onClick={this.delOptionsItem.bind(this, index, optionsIndex, item.quesType)} />
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                )
                            })
                        }
                        <Button className='addQuestion' onClick={this.addQuestion.bind(this)}>+添加题目</Button>
                    </div>
                    <Button className='save' onClick={this.winnerModuleEdit.bind(this)}>保存</Button>
                </div>
            </ConfigProvider>
        )
    }
}

export default WinterGamesAnswer;